// todaySlice.js
import { createSlice, nanoid } from "@reduxjs/toolkit";

const normalizeGrams = (grams, fallback = 100) => {
  if (grams === "") return "";
  const num = Number(grams);
  if (Number.isNaN(num)) return fallback;
  return num;
};

function getGermanDateString(timestamp) {
  return new Date(timestamp).toLocaleDateString('en-CA', {
    timeZone: 'Europe/Berlin'
  }); // "2026-06-24"
}

function getTodayGerman() {
  return new Date().toLocaleDateString('en-CA', {
    timeZone: 'Europe/Berlin'
  });
}

const initialState = {
  entries: []
};

const todaySlice = createSlice({
  name: "today",
  initialState,
  reducers: {
    addMealEntry: {
      reducer(state, action) {
        state.entries.push(action.payload);
      },
      prepare(meal) {
        return {
          payload: {
            id: nanoid(),
            type: "meal",
            mealId: meal.id,
            name: meal.name,
            portions: { ...meal.foodPortions },
            time: Date.now()
          }
        };
      }
    },
    addFoodEntry: {
      reducer(state, action) {
        state.entries.push(action.payload);
      },
      prepare(food, grams = 100) {
        return {
          payload: {
            id: nanoid(),
            type: "food",
            foodId: food.id,
            name: food.name,
            portions: { [food.id]: normalizeGrams(grams) },
            time: Date.now()
          }
        };
      }
    },
    updateMealPortion(state, action) {
      const { entryId, foodId, grams } = action.payload;
      const entry = state.entries.find(e => e.id === entryId);
      if (!entry || entry.type !== "meal") return;
      if (!entry.portions) entry.portions = {};
      entry.portions[foodId] = normalizeGrams(grams);
    },
    updateFoodEntry(state, action) {
      const { entryId, grams } = action.payload;
      const entry = state.entries.find(e => e.id === entryId);
      if (!entry || entry.type !== "food") return;
      const foodId = entry.foodId;
      if (!entry.portions) entry.portions = {};
      entry.portions[foodId] = normalizeGrams(grams);
    },
    addFoodToMealEntry(state, action) {
      const { entryId, foodId, grams = 100 } = action.payload;
      const entry = state.entries.find(e => e.id === entryId);
      if (!entry || entry.type !== "meal") return;
      if (!entry.portions) entry.portions = {};
      entry.portions[foodId] = normalizeGrams(grams);
    },
    removeEntry(state, action) {
      state.entries = state.entries.filter(e => e.id !== action.payload);
    },
    setToday(state, action) {
      const today = getTodayGerman();
      state.entries = action.payload.filter(entry =>
        getGermanDateString(entry.time) === today
      );
    },
    clearToday(state) {
      state.entries = [];
    },
  },
  // ✅ NEW
extraReducers: (builder) => {
  builder.addCase("app/rehydrate", (state, action) => {
    const entries = action.payload?.entries;
    if (entries?.length) {
      const today = getTodayGerman();
      state.entries = entries.filter(entry =>
        getGermanDateString(entry.time) === today
      );
    }
  });
},
});

export const {
  addMealEntry,
  addFoodEntry,
  updateMealPortion,
  updateFoodEntry,
  addFoodToMealEntry,
  removeEntry,
  setToday,
  clearToday
} = todaySlice.actions;

export default todaySlice.reducer;